export default __webpack_public_path__ + "static/media/thumbnail_blog_25.30ec553e.jpg";